<template lang='pug' src='./custom-practice-office-bloomingdale.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { openVideo } from '@/methods'

export default {
  data () {
    return {
      showGallery: false,
      swiperOption: {
        initialSlide: 0,
        effect: 'fade',
        speed: 750,
        spaceBetween: 0
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  props: ['props'],
  mixins: [ openVideo ],
  components: {
    Icon
  },
  methods: {
    openGallery (i) {
      this.swiperOption.initialSlide = i
      this.showGallery = !this.showGallery
    },
    closeGallery () {
      this.showGallery = false
      // this.imageIndex = 0
    },
    slidePrev () {
      this.swiper.slidePrev()
    },
    slideNext () {
      this.swiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-practice-office-bloomingdale.vue?2fb860ee